// extracted by mini-css-extract-plugin
export default {"saveButton":"create-exam_saveButton__vxZmH"};